import React from "react";

interface Props {
    size?: number,
    color?: string,
}

const SvgLinkedin = ({size = 16, color = '#FFF'}: Props) => (
    <svg width={size} height={size} viewBox="0 0 16 16">
        <path
            fill={color}
            d="M3.578 5v11H0V5h3.578zm5 0v2.103C9.014 6.517 10.337 5 12.423 5c.244 0 .452.027.642.065.049.008.097.017.145.028.04.011.076.024.114.036a3.568 3.568 0 012.67 3.25l.006.198V16h-3.577V9c-1.118-2.71-3.735.849-3.842.995L8.578 10v6H5V5h3.578zM1.75 0a1.75 1.75 0 11-.001 3.501A1.75 1.75 0 011.75 0z"
        />
    </svg>
);

export default SvgLinkedin;